/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramCurrenciesControllerFindManyQueryResponse } from '../../types/TelegramCurrenciesControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCurrenciesFindMany } from '../../methods/telegramCurrenciesFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCurrenciesFindManyQueryKey = () => [{ url: '/api/telegram/currencies' }] as const;

export type TelegramCurrenciesFindManyQueryKey = ReturnType<typeof telegramCurrenciesFindManyQueryKey>;

export function telegramCurrenciesFindManyQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCurrenciesFindManyQueryKey();
  return queryOptions<
    TelegramCurrenciesControllerFindManyQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramCurrenciesControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCurrenciesFindMany(config);
    },
  });
}

/**
 * {@link /api/telegram/currencies}
 */
export function useTelegramCurrenciesFindMany<
  TData = TelegramCurrenciesControllerFindManyQueryResponse,
  TQueryData = TelegramCurrenciesControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = TelegramCurrenciesFindManyQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCurrenciesControllerFindManyQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCurrenciesFindManyQueryKey();

  const query = useQuery(
    {
      ...telegramCurrenciesFindManyQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
